import { tracked } from '@glimmer/tracking';

import InfolayerItemBase, { EXPIRE_ERROR } from 'webapp/models-custom/infolayer-item/base';
import { Type as GeneralType } from 'webapp/models-custom/infolayer-item/general';

export default abstract class InfolayerItemSnapshotBase extends InfolayerItemBase {
	@tracked status = GeneralType.LOADING;
	@tracked errorText = '';

	override get classes(): string {
		return super.classes + ' ' + this.status;
	}

	get isLoading() {
		return this.status === GeneralType.LOADING;
	}

	get isError() {
		return this.status === GeneralType.ERROR;
	}

	setError(errorText = '') {
		this.status = GeneralType.ERROR;
		this.errorText = errorText || 'Unknown error';
		this.expire(EXPIRE_ERROR);
	}

	setDone(_args: unknown) {
		this.status = GeneralType.OK;
		this.expire(null); // don't expire
	}

	protected isSameType(item: InfolayerItemBase) {
		return (
			item instanceof InfolayerItemSnapshotBase &&
			item.errorText === this.errorText &&
			this.isError
		);
	}

	checkIfDuplicated(items: InfolayerItemBase[]): boolean {
		return items.some((item) => {
			return this.isSameType(item);
		});
	}
}
